export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/access/index/resources/computed.js